import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { SvgHelper } from "@app/shared";

@Component({
  selector: "[shadow-type-2]",
  templateUrl: "./shadow-type-2.component.html",
  styleUrl: "./shadow-type-2.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShadowType2Component {
  height = input<number>();

  shadowPoints = [240, 434, 110, 432, 136, 319, 200, 265, 356, 368];
  multiplier = 0.27;

  shadowPath = computed(() => {
    const delta = SvgHelper.calculateDelta(this.height(), this.multiplier);
    return SvgHelper.generateType1ShadowPath(delta, this.shadowPoints);
  });
}
